import * as React from "react";
import { useStaticQuery, graphql, HeadFC } from "gatsby";
import { ReviewSummary } from "@components";
import Layout from "@components/layout";
import Reviews from "@components/reviews";
import { Review } from "@kalabo/golfsavers-common";
import { Text } from "@uikit";
import Seo from "@components/seo";

const ReviewsPage = () => {
  const data = useStaticQuery(graphql`
    query {
      allGolfsaversReviews(sort: { created_at: DESC }) {
        edges {
          node {
            created_at
            id
            name
            rating
            review
            show_name
            title
          }
        }
      }
    }
  `);

  const reviews = data.allGolfsaversReviews.edges.map(
    (edge: any) => edge.node as Review
  );

  return (
    <Layout
      pageTitle="Our Reviews"
      hidePadding
      breadcrumb={[
        { name: "Home", url: "/" },
        {
          name: `Our Reviews`,
          url: "",
        },
      ]}
    >
      <div className="grid pt-8 sm:pt-10 grid-cols-12 gap-x-8">
        <div className="col-span-12 md:col-span-8 lg:col-span-7">
          {" "}
          <Text
            size={35}
            element="h1"
            weight="semibold"
            leading={1.2}
            className="mb-1"
          >
            Our Customer Reviews
          </Text>
          <Text size={17} leading={1.5} color="black80" className="mb-7">
            We want you to know that you're in safe hands with Golfsavers, so we
            solicit feedback from all our customers and publish every review
            here.
          </Text>
          <div className="md:hidden">
            <ReviewSummary vertical hideButton />
          </div>
          <Reviews data={reviews} />
        </div>
        <div className="hidden md:block col-span-12 md:col-span-4 lg:col-span-5 ">
          <ReviewSummary sticky={true} vertical hideButton />
        </div>
      </div>
    </Layout>
  );
};

export const Head: HeadFC = () => {
  return (
    <Seo
      title={`Our Customer Reviews | Rated 4.8 out of 5 Based on 1,400+ Reviews`}
      description={`We want you to know that you’re in safe hands with us, so we solicit feedback from all our customers and publish every review here.`}
      keywords={``}
      canonical={``}
    />
  );
};

export default ReviewsPage;
